import Config from '../../config';
import {
  handleErrors,
  handleTimeout,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const submitBatchTaxEntriesForApproval = async data => await fetch(
  Config.endpoints.BATCH_TAX_ENTRIES,
  {
    method: 'POST',
    body: JSON.stringify(data),
  }
)
  .then(handleErrors({ errorMessage: 'Batch Tax Entries upload failed' }))
  .catch(handleTimeout)
  .then(parseAsJson);

export const validateAndProcessTaxEntries = async ({ periodName, entries }) => await fetch(
  Config.endpoints.VALIDATE_AND_PROCESS_TAX_ENTRIES
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
    body: JSON.stringify(entries),
  }
)
  .then(handleErrors({ errorMessage: 'Validating entries failed' }))
  .then(parseAsJson);
